import React, { useState, Fragment } from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
// import Paper from '@mui/material/Paper';
// import Link from '@mui/material/Link';
import { Link } from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
//import { useAuth0 } from "@auth0/auth0-react";
import Button from '@mui/material/Button';
import Logo from "../images/ProcessProLogo.png"
//import TenantLogo from "../images/_lzsXkQr_400x400.jpg"
import { GetAccessToken, fetcher } from "../components/Dashboard/Utilities";
//import { set } from 'date-fns';
import { useLocation } from 'react-router-dom'
import BarChartIcon from '@mui/icons-material/BarChart';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import GradingIcon from '@mui/icons-material/Grading';
import LanIcon from '@mui/icons-material/Lan';

import ArticleIcon from '@mui/icons-material/Article';
import { NavLink } from 'reactstrap';
import { Navbar, NavbarBrand } from 'reactstrap';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListItemButton from '@mui/material/ListItemButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SaveIcon from '@mui/icons-material/Save';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ComputerIcon from '@mui/icons-material/Computer';

import { makeStyles } from '@material-ui/core/styles';
import { tr } from 'date-fns/locale';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

function login() {
  window.location = window.location.origin + "/manualLogin";
}
function logout() {
  //remove token from local storage
  localStorage.removeItem("userToken");
  window.location = window.location.origin + "/manualLogin";
}
function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <a color="inherit" href="https://theprocesspros.ca/" target='_blank'>
        ProcessPro Software
      </a>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const Profile = (props) => {
  //console.log(props);
  //need to get user data

  //const { user, isAuthenticated, isLoading } = useAuth0();
  //const { user, isAuthenticated, isLoading }= useAuth0();

  //const [user, setUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const LoginButton = () => {
    //const { loginWithRedirect } = useAuth0();
    //const { loginWithRedirect } = login();
    return <Button color='inherit' variant="outlined" onClick={() => login()}> Log In</Button>
    // return <button onClick={() => loginWithRedirect()}>Log In</button>;
  };


  const LogoutButton = () => {
    //const { logout } = useAuth0();

    return (
      <Button variant="outlined" sx={{ mr: 2 }} color='inherit' onClick={() => logout({ returnTo: window.location.origin })}>
        Log Out
      </Button>
    );
  };


  if (isLoading) {
    //return <div>Loading ...</div>;
  }
  if (props.isAuthenticated) {

    //var accessToken; 



    return (

      <Fragment>
        {/* <img src={user.picture} alt={user.name} /> */}
        {/*= <h2>{user.name}</h2> */}

        <LogoutButton></LogoutButton>
        <span id='loggedInUser'>{props.user} </span>{props.isAdmin && <span>(Admin)</span>}
      </Fragment >

    );
  }
  else {

    return (

      <Fragment>
        {/* <img src={user.picture} alt={user.name} /> */}
        {/* <h2>{user.name}</h2> */}

        <LoginButton></LoginButton>

      </Fragment >

    );
  }

};
//debugger;
const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const mdTheme = createTheme();


const MainListItems = (props
  , displayLayout
) => {


  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const classes = useStyles();

  const buttonSx = {
    m: 0, p: 0,
    "&.Mui-selected": {
      backgroundColor: "lightgrey"
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#2e8b57"
    },
    ":hover": {
      backgroundColor: "#lightgrey"
    }
  }

  if (!props || !props.userId) {
    return null;
  }
  if (!displayLayout) {
    return null;
  }
  //console.log(props);

  return (
    <React.Fragment>
      <Navbar
        className="my-2"
        color="secondary"
        dark
      >
        <NavbarBrand href="/">
          Privacy
        </NavbarBrand>
      </Navbar>

      <ListItemButton sx={buttonSx}
        selected={selectedIndex === 1}
        onClick={(event) => handleListItemClick(event, 1)}

      >
        <NavLink tag={Link} className="text-dark" to="/dashboard">
          <DashboardIcon />
          <Typography sx={{ display: 'inline', m: 4, paddingRight: 10 }}>Dashboard</Typography>
        </NavLink>
      </ListItemButton>
      <ListItemButton sx={buttonSx}
        selected={selectedIndex === 2}
        onClick={(event) => handleListItemClick(event, 2)}

      >
        <NavLink tag={Link} className="text-dark" to="/Vendor"  >
          <ShoppingCartIcon />
          <Typography sx={{ display: 'inline', m: 4, paddingRight: 10 }}>Vendors</Typography>
        </NavLink>
      </ListItemButton>

      <ListItemButton sx={buttonSx}
        selected={selectedIndex === 3}
        onClick={(event) => handleListItemClick(event, 3)}
      >
        <NavLink tag={Link} className="text-dark" to="/Apps">

          <GradingIcon />
          <Typography sx={{ display: 'inline', m: 4, paddingRight: 10 }}>PIAs</Typography>
        </NavLink>
      </ListItemButton>
      <ListItemButton sx={buttonSx}
        selected={selectedIndex === 4}
        onClick={(event) => handleListItemClick(event, 4)}
      >
        <NavLink tag={Link} className="text-dark" to="/Incidents">
          <WarningAmberIcon />
          <Typography sx={{ display: 'inline', m: 4 }}>Breach Tracking</Typography>
        </NavLink>
      </ListItemButton>

      {/* <ListItemButton sx={{ m: 0, p: 0 }}>
        <NavLink tag={Link} className="text-dark" to="/">
          <BarChartIcon />
          <Typography sx={{ display: 'inline', m: 4 }}>Reports</Typography>
        </NavLink>
      </ListItemButton> */}
      <ListItemButton sx={buttonSx}
        selected={selectedIndex === 5}
        onClick={(event) => handleListItemClick(event, 5)}
      >
        <NavLink tag={Link} className="text-dark" to="/UserManual" target="_blank" >
          <ArticleIcon />
          <Typography sx={{ display: 'inline', m: 4 }}>User Manual</Typography>
        </NavLink>
      </ListItemButton>


      {/* <ListItemButton>
        <ListItemIcon>
          <LayersIcon />
        </ListItemIcon>
        <ListItemText primary="Integrations" />
      </ListItemButton> */}

      {props.hasGovernanceModule && (<>
        <Navbar
          className="my-2"
          color="secondary"
          dark
        >
          <NavbarBrand href="/">
            Data Governance
          </NavbarBrand>
        </Navbar>
        {/* <ListItemButton sx={buttonSx}
          selected={selectedIndex === 6}
          onClick={(event) => handleListItemClick(event, 6)}
        >
          <NavLink tag={Link} className="text-dark" to="/govDashboard">
            <DashboardIcon />
            <Typography sx={{ display: 'inline', m: 4 }}>Dashboard</Typography>
          </NavLink>
        </ListItemButton> */}
        <ListItemButton sx={buttonSx}
          selected={selectedIndex === 7}
          onClick={(event) => handleListItemClick(event, 7)}
        >
          <NavLink tag={Link} className="text-dark" to="/DataSystems">
            <SaveIcon />
            <Typography sx={{ display: 'inline', m: 4 }}>Data Systems</Typography>
          </NavLink>
        </ListItemButton>
        <ListItemButton sx={buttonSx}
          selected={selectedIndex === 11}
          onClick={(event) => handleListItemClick(event, 11)}
        >
          <NavLink tag={Link} className="text-dark" to="/Datausers
          ">
            <PersonIcon />
            <Typography sx={{ display: 'inline', m: 4 }}>Data Users</Typography>
          </NavLink>
        </ListItemButton>
        {/* <ListItemButton sx={buttonSx}
          selected={selectedIndex === 11}
          onClick={(event) => handleListItemClick(event, 11)}
        >
          <NavLink tag={Link} className="text-dark" to="/privacyRequest?id=817191b0-dda0-40f7-b93b-c025ed2be2d2
          ">
            <PersonIcon />
            <Typography sx={{ display: 'inline', m: 4 }}>Test Request</Typography>
          </NavLink>
        </ListItemButton> */}
      </>
      )}
      {props.hasNetworkGovernanceModule && (<>
        <Navbar
          className="my-2"
          color="secondary"
          dark
        >
          <NavbarBrand href="/">
            Network Governance
          </NavbarBrand>
        </Navbar>
        <ListItemButton sx={buttonSx}
          selected={selectedIndex === 8}
          onClick={(event) => handleListItemClick(event, 8)}
        >
          <NavLink tag={Link} className="text-dark" to="/Networks">
            <AccountTreeIcon />
            <Typography sx={{ display: 'inline', m: 4 }}>Networks</Typography>
          </NavLink>
        </ListItemButton>
        <ListItemButton sx={buttonSx}
          selected={selectedIndex === 9}
          onClick={(event) => handleListItemClick(event, 9)}>
          <NavLink tag={Link} className="text-dark" to="/ExternalIps">
            <ComputerIcon />
            <Typography sx={{ display: 'inline', m: 4 }}>External Ips</Typography>
          </NavLink>
        </ListItemButton>
        <ListItemButton sx={buttonSx}
          selected={selectedIndex === 10}
          onClick={(event) => handleListItemClick(event, 10)}
        >
          <NavLink tag={Link} className="text-dark" to="/vlans">
            <LanIcon />
            <Typography sx={{ display: 'inline', m: 4 }}>Vlans</Typography>
          </NavLink>
        </ListItemButton>
        <ListItemButton sx={buttonSx}
          selected={selectedIndex === 11}
          onClick={(event) => handleListItemClick(event, 11)}
        >
          <NavLink tag={Link} className="text-dark" to="/Pias">
            <GradingIcon />
            <Typography sx={{ display: 'inline', m: 4, paddingRight: 10 }}>PIAs</Typography>
          </NavLink>
        </ListItemButton>
      </>
      )}

    </React.Fragment>


  );
}

// const SecondaryListItems = (props) => {
//   const classes = useStyles();
//   const [selectedIndex, setSelectedIndex] = React.useState(1);


//   const handleListItemClick = (event, index) => {
//     setSelectedIndex(index);
//   };
//   const buttonSx = { m: 0, p: 0, 
//       "&.Mui-selected": {
//          backgroundColor: "lightgrey"
//        },
//        "&.Mui-focusVisible": {
//          backgroundColor: "#2e8b57"
//        },
//        ":hover": {
//          backgroundColor: "#lightgrey"
//        }
//  }

//  if(!props.hasGovernanceModule){
//        return null;
//  }

//   return (
//     <React.Fragment>
//       <Navbar
//         className="my-2"
//         color="secondary"
//         dark
//       >
//         <NavbarBrand href="/">
//           Governance
//         </NavbarBrand>
//       </Navbar>
//       <ListItemButton sx={buttonSx}
//       selected={selectedIndex === 6}
//       onClick={(event) => handleListItemClick(event, 6)}
//       >
//         <NavLink tag={Link} className="text-dark" to="/govDashboard">
//           <DashboardIcon />
//           <Typography sx={{ display: 'inline', m: 4 }}>Dashboard</Typography>
//         </NavLink>
//       </ListItemButton>
//       <ListItemButton sx={buttonSx}
//        selected={selectedIndex === 7}
//        onClick={(event) => handleListItemClick(event, 7)}
//       >
//         <NavLink tag={Link} className="text-dark" to="/DataSystems">
//           <SaveIcon />
//           <Typography sx={{ display: 'inline', m: 4 }}>Data Governance</Typography>
//         </NavLink>
//       </ListItemButton>
//       <ListItemButton sx={buttonSx}
//        selected={selectedIndex === 8}
//        onClick={(event) => handleListItemClick(event, 8)}
//       >
//         <NavLink tag={Link} className="text-dark" to="/Networks">
//           <AccountTreeIcon />
//           <Typography sx={{ display: 'inline', m: 4 }}>Networks</Typography>
//         </NavLink>
//       </ListItemButton>
//       <ListItemButton sx={buttonSx}
//        selected={selectedIndex === 9}
//        onClick={(event) => handleListItemClick(event, 9)}>
//         <NavLink tag={Link} className="text-dark" to="/ExternalIps">
//           <ComputerIcon />
//           <Typography sx={{ display: 'inline', m: 4 }}>External Ips</Typography>
//         </NavLink>
//       </ListItemButton>
//       <ListItemButton sx={buttonSx}
//        selected={selectedIndex === 10}
//        onClick={(event) => handleListItemClick(event, 10)}
//       >
//         <NavLink tag={Link} className="text-dark" to="/vlans">
//           <LanIcon />
//           <Typography sx={{ display: 'inline', m: 4 }}>Vlans</Typography>
//         </NavLink>
//       </ListItemButton>
//     </React.Fragment>

//   );
// }

const Layout = ({ children }) => {

  //const { isAuthenticated } = useAuth0();
  const [accessToken, setAccessToken] = useState(false);
  const isAuthenticated = localStorage.getItem("userToken") !== null;

  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const [tenantName, setTenantName] = useState(false);
  const [adminUser, setAdminUser] = useState(false);
  const [user, setUser] = useState(false);
  const [logoFile, setLogoFile] = useState(false);
  const [hasGovernanceModule, setHasGovernanceModule] = useState(true);
  //const [displayLayout, setDisplayLayout] = useState(true);
  const location = useLocation();
  //debugger;
  //todo: generalize this to all reports
  var reportDisplay = (location.pathname.indexOf('Report') !== -1);
  //var showLayout = (location.pathname.indexOf('pireport') === -1 && location.pathname.indexOf('approvalreport') === -1);
  var displayLayout = !reportDisplay || !(!isAuthenticated && reportDisplay) || isAuthenticated;
  const [responseData, setResponseData] = useState(false);



  if (isAuthenticated && !responseData) {

    var token = localStorage.getItem("userToken");
    //from auth0 for testing

    //fetch user data
    let args = ['user', token];
    //console.log(args);
    fetcher(args).then((responseData) => {
      //debugger;
      //console.log(responseData);
      setResponseData(responseData);
      setTenantName(responseData.tenantName);
      setAdminUser(responseData.isSuperAdmin);
      setLogoFile(responseData.logoFile);
      setUser(responseData.userEmail);

      setHasGovernanceModule(responseData.hasGovernanceModule);

    })

  }


  // GetAccessToken(setAccessToken, accessToken).then(result => {
  //   debugger;
  //   accessToken = localStorage.getItem("userToken");
  //   isAuthenticated = localStorage.getItem("userToken") !== null;

  //   if (accessToken) {

  //     if (isAuthenticated && !responseData) {
  //       //fetch user data
  //       let args = ['user', accessToken];
  //       //console.log(args);
  //       fetcher(args).then((responseData) => {
  //         //debugger;
  //         //console.log(responseData);
  //         setResponseData(responseData);
  //         setTenantName(responseData.tenantName);
  //         setAdminUser(responseData.isSuperAdmin);
  //         setLogoFile(responseData.logoFile);
  //         setHasGovernanceModule(responseData.hasGovernanceModule);

  //       })
  //     }
  //   }

  // }).catch(err => {

  // });



  // GetAccessToken(setAccessToken, accessToken).then(result => {
  //   // console.log(accessToken);
  //   if (accessToken) {
  //     //debugger;
  //     if (isAuthenticated && !responseData) {
  //       //fetch user data
  //       let args = ['user', accessToken];
  //       //console.log(args);
  //       fetcher(args).then((responseData) => {
  //         //debugger;
  //         //console.log(responseData);
  //         setResponseData(responseData);
  //         setTenantName(responseData.tenantName);
  //         setAdminUser(responseData.isSuperAdmin);
  //         setLogoFile(responseData.logoFile);
  //         setHasGovernanceModule(responseData.hasGovernanceModule);

  //       })
  //     }
  //   }

  // }).catch(err => {

  // });


  return (

    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>

        <CssBaseline />
        {displayLayout &&
          <Fragment>
            <AppBar position="absolute" open={open}>

              <Toolbar
                sx={{
                  pr: '24px', // keep right padding when drawer closed
                }}
              >

                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={toggleDrawer}
                  sx={{
                    marginRight: '36px',
                    ...(open && { display: 'none' }),
                  }}
                >
                  <MenuIcon />
                </IconButton>

                {tenantName && !adminUser &&
                  <Box
                    component="img"
                    sx={{
                      height: 60,
                      maxWidth: 220,
                      paddingRight: 1
                    }}
                    alt="Your logo."
                    src={"/images/" + logoFile}
                  //src="/images/_lzsXkQr_400x400.jpg"
                  />}
                {/* {!adminUser && tenantName && (<Image  src ='src/images/_lzsXkQr_400x400.jpg'></Image>)  }  */}
                <Typography
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1 }}
                >
                  ProcessPro Privacy  {
                    // !adminUser && tenantName && (<span>{' - ' + tenantName}</span>)
                    tenantName && (<span>{' - ' + tenantName}</span>)
                  }
                </Typography>
                <Typography>
                  <Profile isAdmin={adminUser} isAuthenticated={isAuthenticated} user={user}></Profile>
                </Typography>
                {/* {isAuthenticated && (
                                <IconButton color="inherit">
                                    <Badge badgeContent={0} color="secondary">
                                        <NotificationsIcon />
                                    </Badge>
                                </IconButton>
                            )} */}
              </Toolbar>
            </AppBar>

            <Drawer variant="permanent" open={open}>
              <Toolbar
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  px: [1],
                }}
              >
                <Box
                  component="img"
                  sx={{
                    height: 60,
                  }}
                  alt="Your logo."
                  src={Logo}
                />
                <IconButton onClick={toggleDrawer}>
                  <ChevronLeftIcon />
                </IconButton>
              </Toolbar>
              <Divider />
              {/* {isAuthenticated && ( */}
              <List component="nav">
                {MainListItems(responseData, true)}
                <Divider sx={{ my: 1 }} />

                {/* {hasGovernanceModule && SecondaryListItems(responseData)} */}
                {/* {SecondaryListItems(responseData)} */}
              </List>
              {/* )} */}
            </Drawer>
          </Fragment>
        }
        {!displayLayout &&
          <Fragment>
            {MainListItems(responseData, displayLayout)}
          </Fragment>}
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />

          <Container
            sx={{ mt: 1, ml: 0, mr: 0 }}
            maxWidth={false}
          >
            {children}
            {/* {this.props.children} */}
            {displayLayout &&
              <Copyright sx={{ pt: 4 }} />
            }
          </Container>

        </Box>
      </Box>
    </ThemeProvider>

  );
}

export default Layout